import { Action } from '@ngrx/store';
import { BaseFormConfig } from '../models/base-form-config';
import { Catalog } from '@cemex-core/cmx-api/models/catalogs/catalog';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { ISpecificationNewForm } from '../models/specification-new-form.interface';
import { IWizardSpecification } from '../../../../shared/modules/configurable-form/models/i-wizard-specification';
import { Plant } from '@cemex-core/cmx-api/models/order-management/plant';
import { Profile } from '@cemex-core/cmx-api/models/profiles-management/profile';
import { SalesDocumentTypeIdType } from '../../../../shared/constants/sales-document-type-id';
import { SpecificationFormValues } from '../models/specification-form-values';
import { Order, ProductOP } from '@cemex-core/cmx-api';
import { CatalogEntry } from '@cemex-core/cmx-api/models/catalogs/catalog-entry';

export const RESET = '[Specification] Reset';

export const LOAD_CONFIG = '[Specification] Load Config';
export const LOAD_CONFIG_COMPLETE = '[Specification] Load Config Complete';

export const LOAD_CATALOGS = '[Specification] Load Catalogs';
export const LOAD_CATALOGS_COMPLETE = '[Specification] Load Catalogs Complete';

export const LOAD_PRODUCTS_SELECTION = '[Specification] Load Products Selection';
export const LOAD_PRODUCTS_SELECTION_COMPLETE = '[Specification] Load Products Selection Complete';
export const LOAD_PRODUCTS_UL_SELECTION = '[Specification] Load Products UniversalLink Selection';
export const LOAD_PRODUCTS_UL_SELECTION_COMPLETE = '[Specification] Load Products UniversalLinkSelection Complete';

export const LOAD_PROJECT_PROFILES = '[Specification] Load Project Profiles';
export const LOAD_PROJECT_PROFILES_COMPLETE = '[Specification] Load Project Profiles Complete';

export const LOAD_CONTRACT = '[Specification] Load Contract';
export const LOAD_CONTRACT_COMPLETE = '[Specification] Load Contract Complete';

export const SET_FORM_VALUES = '[Specification] Set form values';
export const ADD_NEW_FORM = '[Specification] Add new form';
export const DELETE_FORM = '[Specification] DELETE form';

export const RESET_FORM_VALUES = '[Specification] Reset form values';

export const LOAD_PRODUCT_FROM_STORE = '[Specification] Load Product From Store';
export const LOAD_PRODUCT_FROM_STORE_SUCCESS = '[Specification] Load Product From Store Success';

export const POPULATE_PRODUCT_FROM_OPEN_CATALOG = '[Specification] Populate Product From Open catalog';
export const POPULATE_PLANT_FROM_OPEN_CATALOG = '[Specification] Populate Plant From Open catalog';
export const POPULATE_PLANTS_FROM_OPEN_CATALOG = '[Specification] Populate Plants From Open catalog';

export const RESET_PLANTS = '[Specification] Reset Plants';

export const LOADED_FOR_PUMP_FILTER = '[Specification] Load complete for pump filter';

export const LOAD_PRODUCT_FROM_API = '[Specification] Load Product From Api';
export const LOAD_PRODUCT_FROM_API_FAIL = '[Specification] Load Product From Api Fail';

export const SET_CAN_ADD_MULTIPLE_PRODUCTS = '[Specification] Set can add multiple products';

export const SELECT_PRODUCT = '[Specification] Select Product';

export const IGNORE_PUMPING_SERVICE_COMMAND = '[Specification] Ignore Pumping Service Command';
export const SHOW_TOP_PRODUCTS_LOADING_SPINNER = '[Specification] Turn off loading spinner for top products';
export const PUMP_DISPLAY_WARNING_MSG =
  '[Specification] This displays the message aboyt the product not being pumpable';

export const ADD_CUSTOM_SPACING = '[Specification] Add custom spacing to catalogs';

export class SpecificationLoadConfigAction implements Action {
  readonly type = LOAD_CONFIG;

  constructor(public payload: IWizardSpecification) {}
}

export class SpecificationLoadConfigCompleteAction implements Action {
  readonly type = LOAD_CONFIG_COMPLETE;

  constructor(public payload: BaseFormConfig) {}
}

export class SpecificationLoadCatalogsAction implements Action {
  readonly type = LOAD_CATALOGS;

  constructor(public payload?: Order) {}
}

export class SpecificationLoadCatalogsCompleteAction implements Action {
  readonly type = LOAD_CATALOGS_COMPLETE;

  constructor(public payload: Catalog[]) {}
}

export class SpecificationLoadProductsSelectionAction implements Action {
  readonly type = LOAD_PRODUCTS_SELECTION;

  constructor(public payload: SalesDocumentTypeIdType[]) {}
}
export class SpecificationLoadProductsULSelectionAction implements Action {
  readonly type = LOAD_PRODUCTS_UL_SELECTION;

  constructor(public payload: SalesDocumentTypeIdType[]) {}
}

export class SpecificationLoadProductsSelectionCompleteAction implements Action {
  readonly type = LOAD_PRODUCTS_SELECTION_COMPLETE;

  constructor(public payload: IProduct[]) {}
}
export class SpecificationLoadProductsULSelectionCompleteAction implements Action {
  readonly type = LOAD_PRODUCTS_UL_SELECTION_COMPLETE;

  constructor(public payload: ProductOP[]) {}
}

export class SpecificationPopulatePlantFromOpenCatalogAction implements Action {
  readonly type = POPULATE_PLANT_FROM_OPEN_CATALOG;

  constructor(public payload: Plant) {}
}

export class SpecificationPopulatePlantsFromOpenCatalogAction implements Action {
  readonly type = POPULATE_PLANTS_FROM_OPEN_CATALOG;

  constructor(public payload: Plant[]) {}
}

export class SpecificationLoadProjectProfilesAction implements Action {
  readonly type = LOAD_PROJECT_PROFILES;

  constructor() {}
}

export class SpecificationLoadProjectProfilesCompleteAction implements Action {
  readonly type = LOAD_PROJECT_PROFILES_COMPLETE;

  constructor(public payload: Profile[]) {}
}

export class SpecificationLoadContractAction implements Action {
  readonly type = LOAD_CONTRACT;

  constructor(public payload: { productId: number | string }) {}
}

export class SpecificationLoadContractCompleteAction implements Action {
  readonly type = LOAD_CONTRACT_COMPLETE;

  constructor(public payload: Profile[]) {}
}

export class SpecificationSetFormValuesAction implements Action {
  readonly type = SET_FORM_VALUES;

  constructor(public payload: SpecificationFormValues[]) {}
}

export class SpecificationAddNewFormAction implements Action {
  readonly type = ADD_NEW_FORM;

  constructor(public payload: ISpecificationNewForm) {}
}

export class SpecificationDeleteFormAction implements Action {
  readonly type = DELETE_FORM;

  constructor(public payload: number | string) {}
}

export class SpecificationResetFormValuesAction implements Action {
  readonly type = RESET_FORM_VALUES;

  constructor() {}
}

export class SpecificationLoadProductFromStoreAction implements Action {
  readonly type = LOAD_PRODUCT_FROM_STORE;

  constructor(public payload: { productCode: string }) {}
}

export class SpecificationLoadProductFromStoreSuccessAction implements Action {
  readonly type = LOAD_PRODUCT_FROM_STORE_SUCCESS;

  constructor(public payload: IProduct) {}
}

export class SpecificationPopulateProductFromOpenCatalogAction implements Action {
  readonly type = POPULATE_PRODUCT_FROM_OPEN_CATALOG;

  constructor(public payload: IProduct) {}
}

export class SpecificationLoadProductFromApiAction implements Action {
  readonly type = LOAD_PRODUCT_FROM_API;

  constructor(public payload: { productCode: string }) {}
}

export class SpecificationLoadProductFromApiFailAction implements Action {
  readonly type = LOAD_PRODUCT_FROM_API_FAIL;

  constructor() {}
}

export class SpecificationSelectProductAction implements Action {
  readonly type = SELECT_PRODUCT;

  constructor(public payload: IProduct) {}
}

export class SpecificationSetCanAddMultipleProductsAction implements Action {
  readonly type = SET_CAN_ADD_MULTIPLE_PRODUCTS;

  constructor(public payload: boolean) {}
}

export class SpecificationResetAction implements Action {
  readonly type = RESET;

  constructor(payload: any) {}
}

export class SpecificationResetPlantsAction implements Action {
  readonly type = RESET_PLANTS;

  constructor() {}
}

export class SpecificationIgnorePumpingServiceCommandAction implements Action {
  readonly type = IGNORE_PUMPING_SERVICE_COMMAND;

  constructor(public payload: boolean) {}
}

export class SpecificationTopProductsShowSpinnerAction implements Action {
  readonly type = SHOW_TOP_PRODUCTS_LOADING_SPINNER;

  constructor(public payload: boolean) {}
}

export class SpecificationIgnorePumpAction implements Action {
  readonly type = LOADED_FOR_PUMP_FILTER;

  constructor(public payload: boolean) {}
}

export class SpecificationDisplayWarningMsgAction implements Action {
  readonly type = PUMP_DISPLAY_WARNING_MSG;

  constructor(public payload: boolean) {}
}

export class AddCustomSpacingAction implements Action {
  readonly type = ADD_CUSTOM_SPACING;

  constructor(public payload: CatalogEntry) {}
}

export type SpecificationActions =
  | SpecificationLoadConfigAction
  | SpecificationResetAction
  | SpecificationLoadConfigCompleteAction
  | SpecificationLoadCatalogsAction
  | SpecificationLoadCatalogsCompleteAction
  | SpecificationLoadProductsSelectionAction
  | SpecificationLoadProductsULSelectionAction
  | SpecificationLoadProductsSelectionCompleteAction
  | SpecificationLoadProductsULSelectionCompleteAction
  | SpecificationLoadProjectProfilesAction
  | SpecificationLoadProjectProfilesCompleteAction
  | SpecificationSetFormValuesAction
  | SpecificationLoadProductFromStoreAction
  | SpecificationLoadProductFromStoreSuccessAction
  | SpecificationLoadProductFromApiAction
  | SpecificationLoadProductFromApiFailAction
  | SpecificationSelectProductAction
  | SpecificationSetCanAddMultipleProductsAction
  | SpecificationPopulateProductFromOpenCatalogAction
  | SpecificationPopulatePlantFromOpenCatalogAction
  | SpecificationPopulatePlantsFromOpenCatalogAction
  | SpecificationResetPlantsAction
  | SpecificationResetFormValuesAction
  | SpecificationAddNewFormAction
  | SpecificationDeleteFormAction
  | SpecificationIgnorePumpingServiceCommandAction
  | SpecificationTopProductsShowSpinnerAction
  | SpecificationIgnorePumpAction
  | SpecificationDisplayWarningMsgAction
  | AddCustomSpacingAction;
